import { useState } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import {
  Tooltip,
  IconButton,
  Menu,
  MenuList,
  Box,
  Tab as MuiTab,
  Tabs as MuiTabs,
  Typography,
  Button,
} from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { NotificationList } from './NotificationList';
import { NotificationSettings } from './NotificationSettings';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`horizontal-tabpanel-${index}`}
      aria-labelledby={`horizontal-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `horizontal-tab-${index}`,
    'aria-controls': `horizontal-tabpanel-${index}`,
  };
}

const Tabs = styled(MuiTabs)(() => ({
  '& .MuiTabs-flexContainer': {
    display: 'flex',
    justifyContent: 'end',
  },
}));

const Tab = styled(MuiTab)(() => ({
  minWidth: 0,
  '& .Mui-selected': {
    border: '0px',
  },
  '& .MuiButtonBase-root': {
    backgroundColor: '#ffffff',
  },
  '& svg': {
    width: '0.835em',
    height: '0.835em',
  },
}));

export const Notification = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleBackToNotificationList = (event) => {
    event.stopPropagation();
    setValue(0);
  };

  return (
    <>
      <Tooltip
        title="Notifications"
        placement="bottom"
        arrow
      >
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <NotificationsNoneOutlinedIcon sx={{ color: '#2e323a' }} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuList sx={{ minWidth: '340px', p: 0 }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
            }}
          >
            {value === 0 ? (
              <Typography sx={{ fontWeight: 500, fontSize: '14px' }}>Notifications</Typography>
            ) : (
              <Button
                startIcon={<ChevronLeftIcon />}
                sx={{ px: 0 }}
                onClick={handleBackToNotificationList}
              >
                Back
              </Button>
            )}
            <Tabs
              aria-label="notifications"
              value={value}
              onChange={handleChange}
            >
              <Tab
                icon={<DraftsOutlinedIcon sx={{ color: '#2e323a' }} />}
                {...a11yProps(0)}
                onClick={(e) => e.stopPropagation()}
              />
              <Tab
                icon={<SettingsOutlinedIcon sx={{ color: '#2e323a' }} />}
                {...a11yProps(1)}
                onClick={(e) => e.stopPropagation()}
              />
            </Tabs>
          </Box>
          <TabPanel
            value={value}
            index={0}
          >
            <NotificationList />
          </TabPanel>
          <TabPanel
            value={value}
            index={1}
          >
            <NotificationSettings />
          </TabPanel>
        </MenuList>
      </Menu>
    </>
  );
};
